// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0c943434","14":"59c44ec7","77":"b55078a5","224":"0837bb83","227":"413080d3","237":"5db4b344","276":"ad9f7fcd","347":"36a3ae28","350":"13818397","540":"1a1435e1","810":"a02a19e7","936":"e8b1aa87","970":"f25d0f2d"}[chunkId] + ".chunk.js";
};